import { isElement } from '../dom/api';
import { isObject } from '../misc/object';
export function resolveDomTarget(obj) {
    if (isElement(obj))
        return obj;
    if (isObject(obj) && isElement(obj.$host))
        return obj.$host;
    return null;
}
